export default __webpack_public_path__ + "static/media/sign-upload-hover-icon.123412c8.svg";